<template>
  <div>
    <Modal width="50%" v-model="showRemoval" title="自提出库确认" @on-ok="submint" @on-cancel="cancels" :loading="loading">
      <Form ref="formValidate" label-position="right" inline :model="formDate" :rules="ruleValidate" :label-width="110">
        <FormItem label="交付计划编号">
          <Input disabled v-model="stockRemVal.id" style="width:200px" />
        </FormItem>
        <!-- <FormItem label="预期交付日期">
          <Input disabled v-model="stockRemVal.expectedDeliveryDate" style="width:180px" />
        </FormItem> -->
        <FormItem label="总计划数">
          <Input disabled v-model="stockRemVal.totalAmount" style="width:200px" />
        </FormItem>
        <FormItem label="完成数">
          <Input disabled v-model="stockRemVal.finishAmount" style="width:200px" />
        </FormItem>
        <FormItem label="租借人">
          <!-- <leasee-select disabled roleType="LEASEE" v-model="stockRemVal.customerId" /> -->
          <dict-select  disabled v-model="stockRemVal.customerId"  namespace="bizObjects" id="member"/>
        </FormItem>
        <FormItem label="标的物小类">
          <dict-select disabled namespace="target" id="type" :exclusion="[]" v-model="stockRemVal.targetType" />
        </FormItem>
        <FormItem label="待交付数">
          <Input disabled v-model="stockRemVal.totalAmount - stockRemVal.finishAmount" style="width:200px" />
        </FormItem>
        <FormItem label="自提数量" prop="confirmAmount">
          <InputNumber :min="1" v-model="formDate.confirmAmount" style="width:200px" />
        </FormItem>
        <FormItem label="交付时间" prop="confirmTime">
          <DatePicker type="date" :editable="false" :options="optionsDate" placeholder="请选择日期" v-model="formDate.confirmTime" @on-change="onChangeTime" style="width: 200px"></DatePicker>
        </FormItem>
        <br />
        <FormItem label="备注">
          <Input v-model="formDate.selfPickAckComment" type="textarea" style="width:490px" />
        </FormItem>
        <br />
        <FormItem label="上传附件">
          <upload ref="upFiles" :height="70" :width="489" title="上传附件" @success="uploadSuccess" @delete="onDelete"></upload>
        </FormItem>
        <!-- <FormItem label="是否校验库存" prop="isStronglyValidateInventory">
                    <Select v-model="formDate.isStronglyValidateInventory" placeholder="请选择" style="width:180px">
                        <Option value="true">是</Option>
                        <Option value="no">否</Option>
                    </Select>
                </FormItem>-->
      </Form>
    </Modal>
  </div>
</template>

<script>
import upload from "@/components/upload/upload";
import leaseeSelect from "@/components/select/payee-select.vue";
import dictSelect from "@/components/select/dict-select.vue";
export default {
  components: { upload, leaseeSelect, dictSelect },
  data() {
    return {
      loading: true,
      stockRemVal: {},
      showRemoval: false,
      formDate: {
        deliveryPlanId: "",
        confirmTime: "",
        confirmAmount: null,
        isStronglyValidateInventory: true,
        attachmentFileIds: [],
        selfPickAckComment: "", //备注
      },
      ruleValidate: {
        confirmAmount: [{ required: true, message: "自提数量不能为空！" }],
        confirmTime: [
          { required: true, message: "请选择时间！", trigger: "change" },
        ],
      },
      optionsDate: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
    };
  },
  methods: {
    openModal(data) {
      this.showRemoval = true;
      this.stockRemVal = data;
    },
    // 时间
    onChangeTime(val) {
      this.formDate.confirmTime = val;
    },
    // 上传附件回调
    uploadSuccess({ body }) {
      this.formDate.attachmentFileIds.push(body);
    },
    // 上传附件删除回调
    onDelete({ id }) {
      this.formDate.attachmentFileIds = this.formDate.attachmentFileIds.filter(
        (item) => item != id
      );
    },
    submint() {
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          this.formDate.deliveryPlanId = this.stockRemVal.id;
          let data = {
            url: "MID-OPERATE-LEASE/messageService/orderService/selfPickConfirm",
            body: this.formDate,
          };
          this.invoke(data)
            .then((res) => {
              if (!res) {
                this.$Message.success("出库确认成功");
                this.cancels();
                this.$emit("search");
              }
            })
            .catch((err) => {
              this.loading = false;
              setTimeout(() => {
                this.loading = true;
              }, 10);
            });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 10);
        }
      });
    },
    cancels() {
      this.showRemoval = false;
      this.$refs["formValidate"].resetFields();
      this.formDate.attachmentFileIds = [];
      this.$refs.upFiles.$refs.uploadFile.clearFiles();
      this.formDate.selfPickAckComment = "";
    },
  },
};
</script>